import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import {
  login,
  logoutAuth,
  setUsuarioAuth,
} from "../../../global/context/action/auth/login";
import { loginSocial } from "../../../global/context/action/auth/loginSocial";
import {
  checkBiometric,
  loginWithBiometric,
  checkBiometricEnabled,
  enableBiometric,
} from "../../../global/context/action/auth/loginBiometric";
import { getBiometryTypeName } from "../../../global/services/biometric/biometricService";
import { useHistory, useLocation } from "react-router";
import { logoutVerificaDni } from "../../context/Actions/verificaDni/logoutVerificaDni";
import { logoutRegistro } from "../../context/Actions/registro/logoutRegistro";
import { setListError } from "../../context/Actions/registro/registro";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import {
  showSegundoModal,
  hideSegundoModal,
} from "../../context/Actions/segundoModal/segundoModal";
import { logoutApp } from "../../../global/context/action/auth/logoutApp";
import { logoutMultiTab } from "../../context/Actions/multiTab/logoutMultiTab";
import {
  logoutPaciente,
  resetPaciente,
  wsGetImagenPerfil,
} from "../../context/Actions/paciente/paciente";
import { tokenLogout } from "../../context/Actions/token/logoutToken";
import { logoutPacienteDefault } from "../../context/Actions/paciente/paciente";
import { loginTokenReset } from "../../context/Actions/token/loginToken";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import { getAccessToken } from "../../context/Actions/token/accessToken";
import { logoutLaboTurnos } from "../../context/Actions/turnos/laboTurnos";
import { editaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { resetLaboGrupo } from "../../context/Actions/laboGrupo/laboGrupo";
import {
  vcTokenReset,
  wsGetVcToken,
} from "../../context/Actions/token/vcToken";
import { GlobalContext } from "../../../global/context/Provider";
import { SignInWithApple } from "@capacitor-community/apple-sign-in";
import fechaTurnoFormat from "../../../global/utils/fechaTurnoFormat";
import sliceInput from "../../../global/utils/sliceInput";
import isDniValido from "../../../global/utils/checkDniValido";
import Textos from "../../components/Genericos/Textos/Textos";
import Layout from "./LoginLayout";
import Loading from "../../components/Genericos/Loading/Loading";
import GetVcToken from "../../../global/utils/getVcToken";
import GetVcTokenAccion from "../../../global/utils/getVcTokenAccion";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import Splash from "./Splash/Splash";
import BiometricSplash from "./BiometricSplash/BiometricSplash";
import { setFlgBeneficios } from "_+_Portal/context/Actions/beneficios/beneficios";
import decodeJWT from "global/utils/decodeJWT";
import { Device } from "@capacitor/device";
import { detectarIOS } from "global/utils/detectarIOS";
import { isMobile } from "react-device-detect";
import { getPlatform } from "global/utils/platformDetector";
import { getDefaultRouteAfterLogin } from "_+_Portal/utils/routingStrategy";

const Login = () => {
  const history = useHistory();
  const {
    modalDispatch,
    segundoModalDispatch,
    verificaDniDispatch,
    registroDispatch,
    registroState,
    multiTabDispatch,
    pacienteDispatch,
    tokenState,
    tokenDispatch,
    tokenGoogleDispatch,
    tokenGoogleState,
    pacienteState,
    laboTurnosDispatch,
    laboTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    laboGrupoState,
    laboGrupoDispatch,
    vcTokenState,
    vcTokenDispatch,
    beneficiosState,
    beneficiosDispatch,
    verificaDniState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, authDispatch, toasterDispatch, configState } =
    useContext(GlobalContext);

  let config = localStorage.getItem("config");
  let sectorTurno = JSON.parse(config)?.sectorTurno;

  const resetForm = {
    nro_documento: false,
    nombre: false,
    password: false,
    apellido: false,
    fecha_nacimiento: false,
    email: false,
    idlocalidad: false,
    domicilio: false,
    telefono: false,
    telefono_movil: false,
    obra_social: false,
    plan_obra_social: false,
    tipo_iva: false,
    nro_afiliado: false,
  };

  const [form, setForm] = useState([
    {
      name: "nro_documento",
      value: "",
      inputType: "number",
      headerStr: "Ingresá tu número de documento",
      placeholderText: "12345678",
      errorStr: "El número de documento no es válido.",
      maxLength: "9",
      className: "inputNonScroll rb16m",
      checkError: registroState.registro.listError.nro_documento,
      isRequired: true,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
    {
      name: "password",
      value: "",
      inputType: "number",
      headerStr: "Ingresá tu contraseña",
      placeholderText: "*********",
      errorStr: "La contraseña no es válida.",
      linkStr: "Olvidé mi contraseña",
      className: "inputNonScroll rb16m",
      maxLength: "10",
      checkError: registroState.registro.listError.password,
      isRequired: true,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  ]);
  const [idGoogle, setIdGoogle] = useState("");
  const [flgVcToken, setVcFlgToken] = useState();
  const [flgLogin, setFlgLogin] = useState(false);

  // Estados para biometría
  const [biometricAvailable, setBiometricAvailable] = useState(false);
  const [biometricEnabled, setBiometricEnabled] = useState(false);
  const [biometricLoading, setBiometricLoading] = useState(false);
  const [biometryTypeName, setBiometryTypeName] = useState("Huella Digital");
  const [lastBiometricUser, setLastBiometricUser] = useState(null);
  const [showBiometricSplash, setShowBiometricSplash] = useState(false);
  const [biometricAutoStarted, setBiometricAutoStarted] = useState(false);

  // Necesario para que no haga el loop
  let path = window.location.pathname;
  const search = useLocation().search;

  const loginFormValid = form[0].value.length > 6 && form[1].value.length > 3;

  // ----------------------- BIOMETRÍA ---------------------------------------

  // Verificar disponibilidad de biometría al cargar
  useEffect(() => {
    const initBiometric = async () => {
      // Solo en dispositivos móviles
      const platform = getPlatform();
      if (platform !== "ios" && platform !== "android") {
        return;
      }

      const { isAvailable, biometryType } = await checkBiometric()(
        authDispatch
      );
      setBiometricAvailable(isAvailable);

      if (isAvailable) {
        setBiometryTypeName(getBiometryTypeName(biometryType));

        // Verificar si el usuario tiene biometría habilitada
        const { enabled, lastUser } = await checkBiometricEnabled()(
          authDispatch
        );
        setBiometricEnabled(enabled);
        setLastBiometricUser(lastUser);

        // Si está habilitada y no se ha iniciado aún, mostrar splash de autologin
        if (enabled && lastUser && !biometricAutoStarted) {
          setShowBiometricSplash(true);
        }
      }
    };

    initBiometric();
    // eslint-disable-next-line
  }, []);

  // Auto-iniciar biometría después del countdown
  useEffect(() => {
    if (showBiometricSplash && !biometricAutoStarted) {
      // Esperar 3 segundos antes de iniciar automáticamente
      const autoStartTimer = setTimeout(() => {
        setBiometricAutoStarted(true);
        handleBiometricLogin();
      }, 3000);

      return () => clearTimeout(autoStartTimer);
    }
    // eslint-disable-next-line
  }, [showBiometricSplash, biometricAutoStarted]);

  // Función para login con biometría
  const handleBiometricLogin = () => {
    setBiometricLoading(true);

    loginWithBiometric(
      configState.config.data.sectorTurno,
      (token, data) => {
        // Login exitoso
        setBiometricLoading(false);
        setFlgLogin(true);
        // Ocultar splash si estaba visible
        if (showBiometricSplash) {
          setShowBiometricSplash(false);
        }
      },
      (error) => {
        // Error en login
        setBiometricLoading(false);

        // Si estaba en autologin, ocultar splash y mostrar login normal
        if (showBiometricSplash) {
          setShowBiometricSplash(false);
          showToaster(
            {
              texto:
                "No se pudo autenticar con biometría. Usa tu DNI y contraseña.",
              tipo: "info",
            },
            "centroArriba"
          )(toasterDispatch);
        } else {
          // Si fue intento manual desde el botón
          showToaster(
            {
              texto:
                "No se pudo autenticar con biometría. Intenta con tu DNI y contraseña.",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        }
      }
    )(authDispatch);
  };

  // Función para cancelar el autologin y mostrar login manual
  const handleCancelBiometricSplash = () => {
    setShowBiometricSplash(false);
    setBiometricAutoStarted(true); // Marcar como iniciado para no volver a mostrar
  };

  // Función para ofrecer guardar credenciales después de login exitoso
  const offerBiometricSetup = (dni, password) => {
    if (!biometricAvailable || biometricEnabled) return;

    showSegundoModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Activar Autenticación Biométrica",
        texto: `¿Quieres usar tu ${biometryTypeName} para iniciar sesión la próxima vez? Tus credenciales se guardarán de forma segura en tu dispositivo.`,
        dissmiss: () => hideSegundoModal()(segundoModalDispatch),
      },
      [
        {
          text: "Ahora no",
          clase: "btn-Mensaje b-latex30 rb16m c-latex30",
          accion: () => hideSegundoModal()(segundoModalDispatch),
        },
        {
          text: "Activar",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => {
            hideSegundoModal()(segundoModalDispatch);
            enableBiometric(
              dni,
              password,
              () => {
                setBiometricEnabled(true);
                setLastBiometricUser(dni);
                showToaster(
                  {
                    texto: `${biometryTypeName} activada correctamente`,
                    tipo: "success",
                  },
                  "centroArriba"
                )(toasterDispatch);
              },
              (error) => {
                showToaster(
                  {
                    texto: "No se pudo activar la autenticación biométrica",
                    tipo: "danger",
                  },
                  "centroArriba"
                )(toasterDispatch);
              }
            )(authDispatch);
          },
        },
      ],
      "centro"
    )(segundoModalDispatch);
  };

  // ----------------------- LOGUEO MOBILE ---------------------------------------
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    if (configState.config.data !== null) {
      // Logueo con Google
      const isIOS = detectarIOS();
      if (isIOS) {
        Device.getInfo().then((info) => {
          if (info.platform === "web") {
            GoogleAuth.initialize({
              clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
              scopes: ["profile", "email"],
              grantOfflineAccess: true,
            });
          } else {
            GoogleAuth.initialize();
          }
        });
      } else {
        GoogleAuth.initialize({
          clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          scopes: ["profile", "email"],
          grantOfflineAccess: true,
        });
      }
    }
  }, [configState.config.data]);

  // ----------------------- LOGUEO MOBILE ---------------------------------------

  // Ingreso con redes sociales
  const onClickSocialHandler = (e) => {
    const origin =
      sectorTurno === "44"
        ? "PORTAL"
        : sectorTurno === "64"
          ? "ANDROID"
          : "IOS";
    if (e.target.id === "Google logo") {
      const googleSignIn = async () => {
        let googleUser = await GoogleAuth.signIn();
        if (
          googleUser.authentication.accessToken !== undefined &&
          googleUser.authentication.accessToken !== null &&
          googleUser.authentication.accessToken !== false
        ) {
          loginSocial(
            googleUser.id,
            "google",
            googleUser.authentication.accessToken,
            origin,
            nextStepAuthSocial
          )(authDispatch);
        } else {
          const body = {
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            client_secret: "d1DURzT_lXrShDtz_9-Ep8K0",
            code: googleUser.serverAuthCode,
            grant_type: "authorization_code",
            redirect_uri: "urn:ietf:wg:oauth:2.0:oob",
          };
          setIdGoogle(googleUser.id);
          // setRedSocial("google");
          getAccessToken(body)(tokenGoogleDispatch);
        }
      };
      googleSignIn().catch((eeerrr) => {
        showToaster(
          {
            texto: "Error al ingresar a través de Google!",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      });
    } else if (e.target.id === "Apple logo") {
      let options = {
        clientId: isMobile
          ? "ar.com.dim.portalturnos"
          : "ar.com.dim.portalturnos.sid",
        redirectURI: "https://portal.dim.com.ar/",
        scopes: "email name",
        state: "12345",
        nonce: "nonce",
      };
      SignInWithApple.authorize(options)
        .then(async (result) => {
          if (result !== undefined && result !== null) {
            let payloadToken = decodeJWT(result.response.identityToken);
            // setIdApple(payloadToken.sub);
            // setTokenAppleTemp(result.response.identityToken);
            // setRedSocial("apple");
            //realizo el login Apple (distinto al resto)
            loginSocial(
              payloadToken.sub,
              "apple",
              result.response.identityToken,
              origin,
              nextStepAuthSocial
            )(authDispatch);
          }
        })
        .catch((error) => {
          showToaster(
            {
              texto: "Error al ingresar a través de Apple!",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        });
    }
  };

  useEffect(() => {
    if (
      tokenGoogleState.tokenGoogle.data !== null &&
      tokenGoogleState.tokenGoogle.data !== undefined &&
      tokenGoogleState.tokenGoogle.data !== false
    ) {
      const origin =
        sectorTurno === "44"
          ? "PORTAL"
          : sectorTurno === "64"
            ? "ANDROID"
            : "IOS";
      loginSocial(
        idGoogle,
        "google",
        tokenGoogleState.tokenGoogle.data.data.access_token,
        origin,
        nextStepAuthSocial
      )(authDispatch);
    } else if (
      tokenGoogleState.tokenGoogle.error !== null &&
      tokenGoogleState.tokenGoogle.error !== undefined &&
      tokenGoogleState.tokenGoogle.error !== false
    ) {
      showToaster(
        {
          texto: tokenGoogleState.tokenGoogle.error,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
    //eslint-disable-next-line
  }, [tokenGoogleState]);

  //Logueo Con Facebook
  const responseFacebook = async () => { };

  const dissmiss = () => {
    hideModal()(modalDispatch);
    setListError(resetForm)(registroDispatch);
  };

  const onClickRegisterDni = () => {
    logoutVerificaDni()(verificaDniDispatch);
    logoutRegistro()(registroDispatch);
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    logoutMultiTab()(multiTabDispatch);
    logoutPacienteDefault()(pacienteDispatch);
    showModal(
      "Auth/RegistroIngresoDni/RegistroIngresoDni",
      {
        titulo: "Crear una cuenta",
        dissmiss: dissmiss,
        name: "txtVerificaDni",
        inputType: "number",
        className: "inputNonScroll rb16m",
        headerStr: "Ingresá tu número de documento",
        placeholderText: "12345678",
        errorStr:
          "El valor ingresado debe ser numérico y tener al menos 7 dígitos",
        maxLength: "9",
        isRequired: true,
        inputMode: "numeric",
        pattern: "[0-9]*",
      },
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const onClickChangePassword = () => {
    logoutVerificaDni()(verificaDniDispatch);
    logoutRegistro()(registroDispatch);
    logoutApp(history)(authDispatch);
    logoutPaciente(history)(pacienteDispatch);
    logoutMultiTab()(multiTabDispatch);
    showModal(
      "Auth/CambioPassword/CambioPassword",
      {
        dissmiss: dissmiss,
      },
      null,
      "centro",
      false
    )(modalDispatch);
  };

  //Login y Cambios en el input Form
  const logueando = () => {
    let dto = {
      txtDni: form[0].value,
      txtPassword: form[1].value,
    };
    setFlgLogin(true);
    login(dto, configState.config.data.sectorTurno, (token, data) => {
      // Después del login exitoso, ofrecer configurar biometría
      if (biometricAvailable && !biometricEnabled) {
        setTimeout(() => {
          offerBiometricSetup(form[0].value, form[1].value);
        }, 1000);
      }
    })(authDispatch);
  };

  //reemplazar por utils
  const isPasswordValido = (e) => {
    if (e.target.value.length < 4) {
      return true;
    }
    if (e.target.value.length >= 4) {
      return false;
    }
    if (e.target.value === "") {
      return true;
    }
    return false;
  };

  const onInputsChange = (e) => {
    let formulario = [...form];
    let item = form.filter((item) => item.name === e.target.name)[0];
    let index = form.indexOf(item);
    if (e.target.name === "nro_documento") {
      sliceInput(e);
      let errx = Object.assign({}, registroState.registro.listError);
      item.value = e.target.value;
      formulario[index] = item;
      setForm(formulario);
      errx.nro_documento = !isDniValido(e);
      setListError(errx)(registroDispatch);
    } else if (e.target.name === "password") {
      sliceInput(e);
      let errx = Object.assign({}, registroState.registro.listError);
      item.value = e.target.value;
      formulario[index] = item;
      setForm(formulario);
      errx.password = isPasswordValido(e);
      setListError(errx)(registroDispatch);
    }
  };

  /**
   * Determina la ruta de redirección después del login
   * Usa la estrategia centralizada de routing
   */
  const getRedirectRoute = () => {
    // Manejar beneficios antes de delegar a la estrategia
    const beneficiosActivo = beneficiosState.beneficios.estado === true;
    if (beneficiosActivo) {
      setFlgBeneficios(false)(beneficiosDispatch);
    }

    // Delegar a la estrategia centralizada
    return getDefaultRouteAfterLogin(configState.config.data, {
      beneficiosEstado: beneficiosActivo,
    });
  };

  /**
   * Carga la imagen de perfil del usuario autenticado
   */
  const loadUserProfileImage = () => {
    wsGetImagenPerfil("", (isCorrect, data) => {
      if (isCorrect) {
        const userDto = {
          ...authState.auth.data,
          paciente: {
            ...authState.auth.data.paciente,
            imagenPerfil: data || null,
          },
        };
        setUsuarioAuth(userDto)(authDispatch);
      }
    })(pacienteDispatch);
  };

  // Check autenticación Login + autenticación Token
  useEffect(() => {
    const isAuthenticated =
      authState.auth.data &&
      authState.auth.data?.paciente &&
      sessionStorage.token &&
      flgLogin;

    if (!isAuthenticated || isAuthenticated === undefined) {
      return;
    }

    // Cargar imagen de perfil del usuario
    loadUserProfileImage();

    // Redirigir a la ruta correspondiente
    const redirectRoute = getRedirectRoute();
    history.push(redirectRoute);

    // Resetear flag de login
    setFlgLogin(false);

    // Cleanup function
    return () => {
      logoutVerificaDni()(verificaDniDispatch);
      logoutPacienteDefault()(pacienteDispatch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.auth.data, flgLogin]);

  useEffect(() => {
    if (authState.authTraza.data || authState.authTraza.error !== false) {
      logoutAuth()(authDispatch);
    }
  }, [authState.authTraza.data, authState.authTraza.error]);

  useEffect(() => {
    if (
      pacienteState.paciente.cambioClave !== null &&
      pacienteState.paciente.cambioClave !== undefined &&
      pacienteState.paciente.cambioClave !== ""
    ) {
      if (pacienteState.paciente.cambioClave.origen === "cambioClave") {
        let dto = {
          txtDni: registroState.registro.usuario.nro_documento,
          txtPassword: registroState.registro.usuario.telefono,
        };
        showToaster(
          {
            texto: "Contraseña Correcta!",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
        setFlgLogin(true);
        logoutRegistro()(registroDispatch);
        resetPaciente()(pacienteDispatch);
        login(dto, configState.config.data.sectorTurno)(authDispatch);
        hideModal()(modalDispatch);
      }
    }
    //eslint-disable-next-line
  }, [pacienteState.paciente.cambioClave]);

  //token de video consulta con push a pestaña de VC
  useEffect(() => {
    let vcToken = GetVcToken(search);
    let vcTokenAccion = GetVcTokenAccion(search);
    if (
      vcTokenState.vcToken.data === null &&
      !vcTokenState.vcToken.loading &&
      vcToken !== null &&
      vcToken !== undefined &&
      !flgVcToken
    ) {
      setVcFlgToken(true);
      wsGetVcToken(vcToken, vcTokenAccion)(vcTokenDispatch);
    } else {
      if (vcToken && vcTokenAccion) {
        setUsuarioAuth(vcTokenState.vcToken.data)(authDispatch);
      }
      if (authState.auth.data && vcTokenState.vcToken.data) {
        history.push("/proximosTurnos");
      }
    }
  }, [vcTokenState.vcToken.data, authState.auth.data]);

  useEffect(() => {
    if (vcTokenState.vcToken.error) {
      showToaster(
        {
          texto: vcTokenState.vcToken.error.detail,
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      vcTokenReset()(vcTokenDispatch);
      history.push("/");
    }
  }, [vcTokenState.vcToken.error]);

  const [flgParticular, setFlgParticular] = useState(false);

  useEffect(() => {
    if (
      laboTurnosState.laboTurnos.data !== null &&
      laboTurnosState.laboTurnos.data !== undefined &&
      laboTurnosState.laboTurnos.data !== ""
    ) {
      // si el idProtocolo es menor a 0, no lo dejo avanzar del login y limpio todos los estados.
      if (authState?.auth?.data?.idProtocolo > 0) {
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: laboTurnosState.laboTurnos.data.data,
          grupoMedico: null,
          particular: flgParticular,
          idEstudio: 5,
          descEstudio: "TURNO DE LABORATORIO GENERAL",
          descEspecialidad: null,
          fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
          volverOrigen: "LABORATORIO",
          proceso: "labo",
          dtoBusqueda: {
            fechaInvertida: fechaTurnoFormat(),
            idGrupo: 5,
          },
        })(turnosDisponiblesDispatch);
        if (laboGrupoState.laboGrupo.centros) {
          history.push("/turnosDisponibles");
        }
        if (
          laboTurnosState.laboTurnos.error.detail === "9" ||
          laboTurnosState.laboTurnos.error.detail === "91"
        ) {
          setFlgParticular(true);
        } else {
          setFlgParticular(false);
        }
      } else {
        showToaster(
          {
            texto: "No se encontró un protocolo asociado a una orden digital",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        resetLaboGrupo()(laboGrupoDispatch);
        logoutLaboTurnos()(laboTurnosDispatch);
        loginTokenReset()(tokenDispatch);
        logoutAuth()(authDispatch);
        if (path !== "/") history.push("/");
      }
    }
    //eslint-disable-next-line
  }, [
    laboTurnosState.laboTurnos.data,
    laboGrupoState.laboGrupo.centros,
    tokenState.token.data,
  ]);

  useEffect(() => {
    if (
      tokenState.token.error !== false &&
      tokenState.token.error !== null &&
      tokenState.token.error !== undefined
    ) {
      if (path !== "/") history.push("/");
      //este timeout sirve para realizar las acciones en caso de error, sin él no llega a escuchar los cambios.
      setTimeout(() => {
        logoutAuth()(authDispatch);
        tokenLogout(history)(tokenDispatch);
        showToaster(
          {
            texto: tokenState.token.error.detail,
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }, 1000);
    }
    //eslint-disable-next-line
  }, [tokenState.token.error]);

  useEffect(() => {
    if (
      laboGrupoState.laboGrupo.centros !== null &&
      laboGrupoState.laboGrupo.centros !== undefined
    ) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .centrosLabo !== undefined
      ) {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo.length === 1
        ) {
          let centrosLabo =
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
              .centrosLabo;
          let centro = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.descripcion)
            ),
          ];
          const map = new Map();
          for (const item of centro) {
            if (!centrosLabo.filter((x) => x.descripcion === item).length > 0) {
              if (!map.has(item)) {
                map.set(item);
                //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                const lastItem = centrosLabo[centrosLabo.length - 1];
                centrosLabo.push({
                  id: lastItem.id + 1,
                  descripcion: item,
                  checked: true,
                });
              }
            }
          }
          // guardo los centros
          editaTurnosDisponibles({
            ...turnosDisponiblesState.turnosDisponibles.turnosData,
            filtrosData: {
              ...turnosDisponiblesState.turnosDisponibles.turnosData
                .filtrosData,
              centrosLabo: centrosLabo,
            },
          })(turnosDisponiblesDispatch);
        }
      }
    }
    //eslint-disable-next-line
  }, [laboGrupoState.laboGrupo.centros]);

  //manejo error login.
  useEffect(() => {
    if (!!authState.auth.error) {
      if (authState.auth.error.origen === "portal") {

        const tooManyReq = authState.auth.error.status === 429;
        hideModal()(modalDispatch);
        setTimeout(() => {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: tooManyReq ? "Atención" : "Clave o usuario incorrecto",
              textoNegrita: tooManyReq
                ? "Demasiados intentos. Por favor intentá nuevamente en unos minutos"
                : "Verificá tu clave o usuario e intentá nuevamente",
              texto: authState.auth.error.detail,
              danger: true,
              dissmiss: dissmiss,
            },
            [
              {
                text: "Volver",
                clase: "btn b-latex30 rb16m c-latex30",
                accion: dissmiss,
              },
            ],
            "centro"
          )(modalDispatch);
        }, 100);
        if (!tooManyReq) {
          form[0].value = ""
          form[1].value = ""
        };
      }

      logoutApp(history)(authDispatch);
    }
    //eslint-disable-next-line
  }, [authState.auth.error]);

  //manejo nextStep authSocial
  const nextStepAuthSocial = (
    isCorrect,
    data,
    idRed,
    redSocial,
    tokenRedSocial
  ) => {
    if (isCorrect) {
      // que camino tomar porque devuelvo un token actualmente.
      if (
        data.token !== null &&
        data.token !== undefined &&
        data.auth !== undefined &&
        data.auth !== null
      ) {
        sessionStorage.token = data.token;
        setFlgLogin(true);
        setUsuarioAuth(data.auth)(authDispatch);
      } else if (
        data.mensaje !== null &&
        data.mensaje !== undefined &&
        data.mensaje !== ""
      ) {
        showModal(
          "Auth/VincularLogin/VincularLogin",
          {
            titulo: "Ingresa a Vincular tu Cuenta",
            textoNegrita: data.mensaje,
            texto:
              "Lamentablemente su cuenta no se encuentra vinculada a nuestro Portal. Le socitamos ingresar su Dni para Verificarlo o puede Volver a la pantalla Incial.",
            dissmiss: dissmiss,
            token: tokenRedSocial,
            idRedSocial: idRed,
            redSocial: redSocial,
          },
          "centro"
        )(modalDispatch);
      }
    } else {
      if (
        data.mensaje !== null &&
        data.mensaje !== undefined &&
        data.mensaje !== ""
      ) {
        showToaster(
          {
            texto: data.mensaje,
            tipo: "danger",
            dissmiss: dissmiss,
          },
          "centroArriba"
        )(toasterDispatch);
      }
    }
  };

  return (
    <>
      {showSplash ? (
        <Splash />
      ) : showBiometricSplash ? (
        <BiometricSplash
          onCancel={handleCancelBiometricSplash}
          lastUser={lastBiometricUser}
          biometryTypeName={biometryTypeName}
          autoStartDelay={3000}
        />
      ) : (
        <>
          <Loading
            dataLoading={
              tokenState.token.loading ||
              laboTurnosState.laboTurnos.data ||
              verificaDniState.verificaDni.loading
            }
            color={"c-white"}
            descripcion={
              (tokenState.token.loading && "Validando sesión...") ||
              (laboTurnosState.laboTurnos.loading && "Cargando...") ||
              (verificaDniState.verificaDni.loading && "Verificando DNI...") ||
              "Cargando..."
            }
          />
          <Textos />
          <Layout
            form={form}
            loading={authState.auth.loading}
            onChange={onInputsChange}
            onSubmit={logueando}
            error={authState.auth.error}
            loginFormValid={loginFormValid}
            onClickSocialHandler={onClickSocialHandler}
            onClickRegister={onClickRegisterDni}
            onClickChangePassword={onClickChangePassword}
            responseFacebook={responseFacebook}
            biometricAvailable={biometricAvailable}
            biometricEnabled={biometricEnabled}
            biometricLoading={biometricLoading}
            biometryTypeName={biometryTypeName}
            lastBiometricUser={lastBiometricUser}
            onBiometricLogin={handleBiometricLogin}
          />
        </>
      )}
    </>
  );
};

export default Login;
